export const colors = {
	blue: '#45a6dd',
	green: '#275036',
	red: '#ec3438',
	yellow: '#f7eb23',
	orange: '#f58634',
	purple: '#3e4095',
	lightGreen: '#15a759',
	darkRed: '#ed3237',
};

export const appName = 'LASHMA QAPro';
